// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-viewer-modal .modal-dialog {
  max-width: 85vw;
  width: 85vw;
  margin-top: 5vh;
  margin-bottom: 5vh;
}
.media-viewer-modal .modal-content {
  height: 85vh;
  display: flex;
  flex-direction: column;
}
.media-viewer-modal .modal-header {
  flex: 0 0 auto;
}
.media-viewer-modal .modal-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  width: 100%;
}

.media-viewer-modal__counter {
  margin-left: 12px;
  font-weight: 400;
  color: #6c757d;
  font-size: 0.9rem;
}

.media-viewer-modal__mode-toggle {
  display: inline-flex;
  border: 1px solid #6c757d;
  border-radius: 0.2rem;
  overflow: hidden;
}

.media-viewer-modal__mode-btn {
  border: none;
  background: #fff;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 400;
  padding: 2px 10px;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.media-viewer-modal__mode-btn:hover:not(.media-viewer-modal__mode-btn--active) {
  background: #f1f1f1;
}
.media-viewer-modal__mode-btn + .media-viewer-modal__mode-btn {
  border-left: 1px solid #6c757d;
}

.media-viewer-modal__mode-btn--active {
  background: #6c757d;
  color: #fff;
}

.media-viewer-modal__body {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  display: flex;
}

.media-viewer-modal__scroll {
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.media-viewer-modal__scroll--fit {
  overflow: hidden;
}

.media-viewer-modal__image {
  max-width: none;
  display: block;
  margin: auto;
}

.media-viewer-modal__image--fit {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.media-viewer-modal__video {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  display: block;
}

.media-viewer-modal__video-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #6c757d;
  text-align: center;
}

.media-viewer-modal__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border: none;
  font-size: 2rem;
  line-height: 1;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
}
.media-viewer-modal__arrow:hover {
  background: rgba(0, 0, 0, 0.65);
}

.media-viewer-modal__arrow--prev {
  left: 12px;
}

.media-viewer-modal__arrow--next {
  right: 12px;
}

.media-viewer-modal__thumbs {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 12px 16px;
}

.media-viewer-modal__thumb {
  position: relative;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: #f1f1f1;
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid transparent;
  opacity: 0.6;
  transition: opacity 0.15s ease, border-color 0.15s ease;
}
.media-viewer-modal__thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.media-viewer-modal__thumb:hover {
  opacity: 1;
}

.media-viewer-modal__thumb-icon {
  font-size: 2rem;
}

.media-viewer-modal__thumb-ext {
  font-size: 0.65rem;
  font-weight: 700;
  color: #6c757d;
  letter-spacing: 0.02em;
}

.media-viewer-modal__thumb-actions {
  position: absolute;
  top: -6px;
  left: -6px;
  display: flex;
  gap: 2px;
}

.media-viewer-modal__file-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: auto;
  text-align: center;
}

.media-viewer-modal__file-view-icon {
  font-size: 4rem;
  line-height: 1;
}

.media-viewer-modal__file-view-name {
  max-width: 60vw;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-viewer-modal__file-view-ext {
  font-size: 0.8rem;
  font-weight: 700;
  color: #6c757d;
  letter-spacing: 0.02em;
}

.media-viewer-modal__file-view-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.media-viewer-modal__thumb--active {
  opacity: 1;
  border-color: #6cb200;
}

.media-thumb-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.media-thumb-gallery__item {
  display: flex;
  flex-direction: column;
}

.media-thumb-gallery__image-wrap {
  position: relative;
}

.media-thumb-gallery__image {
  object-fit: contain;
  background: #f1f1f1;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.media-thumb-gallery__file-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: #f1f1f1;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.media-thumb-gallery__file-icon {
  font-size: 1.8rem;
  line-height: 1;
}

.media-thumb-gallery__file-ext {
  font-size: 0.7rem;
  font-weight: 700;
  color: #6c757d;
  letter-spacing: 0.02em;
}

.media-thumb-gallery__actions {
  position: absolute;
  top: -6px;
  left: -6px;
  display: flex;
  gap: 2px;
}

.media-thumb-gallery__action-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 1;
  padding: 0;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.media-thumb-gallery__action-btn:hover:not(.media-thumb-gallery__action-btn--disabled) {
  background: #6cb200;
  color: #fff;
  transform: scale(1.3);
}
.media-thumb-gallery__action-btn.media-thumb-gallery__action-btn--disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.media-thumb-gallery__name {
  margin-top: 4px;
  font-size: 0.8rem;
  color: #6c757d;
}

.media-thumb-gallery__size {
  font-size: 0.75rem;
  color: #adb5bd;
}

.media-thumb-gallery__remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  box-sizing: border-box;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.media-thumb-gallery__remove span {
  display: block;
  line-height: 1;
  margin-top: -1px;
}
.media-thumb-gallery__remove:hover:not(:disabled) {
  background: #dc3545;
  color: #fff;
  transform: scale(1.3);
}
.media-thumb-gallery__remove:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.media-viewer-button--bordered {
  border: 1px solid #6c757d;
  border-radius: 0.2rem;
  padding: 0.25rem 0.5rem;
  line-height: 1;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.media-viewer-button--bordered:hover:not(:disabled) {
  background-color: #6c757d;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/myComponents/MediaViewerModal/MediaViewerModal.scss"],"names":[],"mappings":"AACC;EACC,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAGC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AADF;AAIC;EACC,cAAA;AAFF;AAKC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAHF;;AAOA;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAJD;;AAOA;EACC,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAJD;;AAOA;EACC,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;AAJD;AAMC;EACC,mBAAA;AAJF;AAOC;EACC,8BAAA;AALF;;AASA;EACC,mBAAA;EACA,WAAA;AAND;;AASA;EACC,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;AAND;;AASA;EACC,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAND;;AASA;EACC,gBAAA;AAND;;AASA;EACC,eAAA;EACA,cAAA;EACA,YAAA;AAND;;AASA;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAND;;AASA;EACC,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AAND;;AASA;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAND;AAQC;EACC,+BAAA;AANF;;AAUA;EACC,UAAA;AAPD;;AAUA;EACC,WAAA;AAPD;;AAUA;EACC,cAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAPD;;AAUA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,uDAAA;AAPD;AASC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAPF;AAUC;EACC,UAAA;AARF;;AAYA;EACC,eAAA;AATD;;AAYA;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AATD;;AAYA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;AATD;;AAYA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AATD;;AAYA;EACC,eAAA;EACA,cAAA;AATD;;AAYA;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATD;;AAYA;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AATD;;AAYA;EACC,aAAA;EACA,QAAA;EACA,eAAA;AATD;;AAYA;EACC,UAAA;EACA,qBAAA;AATD;;AAYA;EACC,aAAA;EACA,eAAA;EACA,QAAA;AATD;;AAYA;EACC,aAAA;EACA,sBAAA;AATD;;AAYA;EACC,kBAAA;AATD;;AAYA;EACC,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AATD;;AAYA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AATD;;AAYA;EACC,iBAAA;EACA,cAAA;AATD;;AAYA;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AATD;;AAYA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;AATD;;AAYA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,+EAAA;AATD;AAWC;EACC,mBAAA;EACA,WAAA;EACA,qBAAA;AATF;AAYC;EACC,mBAAA;EACA,YAAA;AAVF;;AAcA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AAXD;;AAcA;EACC,kBAAA;EACA,cAAA;AAXD;;AAcA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;EACA,+EAAA;AAXD;AAaC;EACC,cAAA;EACA,cAAA;EACA,gBAAA;AAXF;AAcC;EACC,mBAAA;EACA,WAAA;EACA,qBAAA;AAZF;AAeC;EACC,mBAAA;EACA,YAAA;AAbF;;AAiBA;EACC,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,yDAAA;AAdD;AAgBC;EACC,yBAAA;EACA,WAAA;AAdF","sourcesContent":[".media-viewer-modal {\n\t.modal-dialog {\n\t\tmax-width: 85vw;\n\t\twidth: 85vw;\n\t\tmargin-top: 5vh;\n\t\tmargin-bottom: 5vh;\n\t}\n\n\t.modal-content {\n\t\theight: 85vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.modal-header {\n\t\tflex: 0 0 auto;\n\t}\n\n\t.modal-title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tgap: 4px 12px;\n\t\twidth: 100%;\n\t}\n}\n\n.media-viewer-modal__counter {\n\tmargin-left: 12px;\n\tfont-weight: 400;\n\tcolor: #6c757d;\n\tfont-size: 0.9rem;\n}\n\n.media-viewer-modal__mode-toggle {\n\tdisplay: inline-flex;\n\tborder: 1px solid #6c757d;\n\tborder-radius: 0.2rem;\n\toverflow: hidden;\n}\n\n.media-viewer-modal__mode-btn {\n\tborder: none;\n\tbackground: #fff;\n\tcolor: #6c757d;\n\tfont-size: 0.8rem;\n\tfont-weight: 400;\n\tpadding: 2px 10px;\n\tline-height: 1.4;\n\tcursor: pointer;\n\ttransition: background-color 0.15s ease, color 0.15s ease;\n\n\t&:hover:not(.media-viewer-modal__mode-btn--active) {\n\t\tbackground: #f1f1f1;\n\t}\n\n\t& + & {\n\t\tborder-left: 1px solid #6c757d;\n\t}\n}\n\n.media-viewer-modal__mode-btn--active {\n\tbackground: #6c757d;\n\tcolor: #fff;\n}\n\n.media-viewer-modal__body {\n\tposition: relative;\n\tflex: 1 1 auto;\n\tmin-height: 0;\n\toverflow: hidden;\n\tpadding: 0;\n\tdisplay: flex;\n}\n\n.media-viewer-modal__scroll {\n\tflex: 1 1 auto;\n\toverflow: auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 16px;\n}\n\n.media-viewer-modal__scroll--fit {\n\toverflow: hidden;\n}\n\n.media-viewer-modal__image {\n\tmax-width: none;\n\tdisplay: block;\n\tmargin: auto;\n}\n\n.media-viewer-modal__image--fit {\n\tmax-width: 100%;\n\tmax-height: 100%;\n\twidth: auto;\n\theight: auto;\n\tobject-fit: contain;\n}\n\n.media-viewer-modal__video {\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tmargin: auto;\n\tdisplay: block;\n}\n\n.media-viewer-modal__video-error {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 12px;\n\tcolor: #6c757d;\n\ttext-align: center;\n}\n\n.media-viewer-modal__arrow {\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tbackground: rgba(0, 0, 0, 0.4);\n\tcolor: #fff;\n\tborder: none;\n\tfont-size: 2rem;\n\tline-height: 1;\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tz-index: 5;\n\n\t&:hover {\n\t\tbackground: rgba(0, 0, 0, 0.65);\n\t}\n}\n\n.media-viewer-modal__arrow--prev {\n\tleft: 12px;\n}\n\n.media-viewer-modal__arrow--next {\n\tright: 12px;\n}\n\n.media-viewer-modal__thumbs {\n\tflex-shrink: 0;\n\tdisplay: flex;\n\tgap: 8px;\n\toverflow-x: auto;\n\toverflow-y: hidden;\n\tpadding: 12px 16px;\n}\n\n.media-viewer-modal__thumb {\n\tposition: relative;\n\twidth: 90px;\n\theight: 90px;\n\tflex-shrink: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 2px;\n\tbackground: #f1f1f1;\n\tcursor: pointer;\n\tborder-radius: 4px;\n\tborder: 2px solid transparent;\n\topacity: 0.6;\n\ttransition: opacity 0.15s ease, border-color 0.15s ease;\n\n\timg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: contain;\n\t}\n\n\t&:hover {\n\t\topacity: 1;\n\t}\n}\n\n.media-viewer-modal__thumb-icon {\n\tfont-size: 2rem;\n}\n\n.media-viewer-modal__thumb-ext {\n\tfont-size: 0.65rem;\n\tfont-weight: 700;\n\tcolor: #6c757d;\n\tletter-spacing: 0.02em;\n}\n\n.media-viewer-modal__thumb-actions {\n\tposition: absolute;\n\ttop: -6px;\n\tleft: -6px;\n\tdisplay: flex;\n\tgap: 2px;\n}\n\n.media-viewer-modal__file-view {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 8px;\n\tmargin: auto;\n\ttext-align: center;\n}\n\n.media-viewer-modal__file-view-icon {\n\tfont-size: 4rem;\n\tline-height: 1;\n}\n\n.media-viewer-modal__file-view-name {\n\tmax-width: 60vw;\n\tfont-weight: 500;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.media-viewer-modal__file-view-ext {\n\tfont-size: 0.8rem;\n\tfont-weight: 700;\n\tcolor: #6c757d;\n\tletter-spacing: 0.02em;\n}\n\n.media-viewer-modal__file-view-actions {\n\tdisplay: flex;\n\tgap: 8px;\n\tmargin-top: 4px;\n}\n\n.media-viewer-modal__thumb--active {\n\topacity: 1;\n\tborder-color: #6cb200;\n}\n\n.media-thumb-gallery {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 8px;\n}\n\n.media-thumb-gallery__item {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.media-thumb-gallery__image-wrap {\n\tposition: relative;\n}\n\n.media-thumb-gallery__image {\n\tobject-fit: contain;\n\tbackground: #f1f1f1;\n\tcursor: pointer;\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 4px;\n}\n\n.media-thumb-gallery__file-tile {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 2px;\n\tbackground: #f1f1f1;\n\tcursor: pointer;\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 4px;\n}\n\n.media-thumb-gallery__file-icon {\n\tfont-size: 1.8rem;\n\tline-height: 1;\n}\n\n.media-thumb-gallery__file-ext {\n\tfont-size: 0.7rem;\n\tfont-weight: 700;\n\tcolor: #6c757d;\n\tletter-spacing: 0.02em;\n}\n\n.media-thumb-gallery__actions {\n\tposition: absolute;\n\ttop: -6px;\n\tleft: -6px;\n\tdisplay: flex;\n\tgap: 2px;\n}\n\n.media-thumb-gallery__action-btn {\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 50%;\n\tborder: 1px solid #d9d9d9;\n\tbackground: #fff;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 11px;\n\tline-height: 1;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\ttext-decoration: none;\n\ttransition: transform 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n\t&:hover:not(.media-thumb-gallery__action-btn--disabled) {\n\t\tbackground: #6cb200;\n\t\tcolor: #fff;\n\t\ttransform: scale(1.3);\n\t}\n\n\t&.media-thumb-gallery__action-btn--disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.6;\n\t}\n}\n\n.media-thumb-gallery__name {\n\tmargin-top: 4px;\n\tfont-size: 0.8rem;\n\tcolor: #6c757d;\n}\n\n.media-thumb-gallery__size {\n\tfont-size: 0.75rem;\n\tcolor: #adb5bd;\n}\n\n.media-thumb-gallery__remove {\n\tposition: absolute;\n\ttop: -6px;\n\tright: -6px;\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 50%;\n\tborder: 1px solid #d9d9d9;\n\tbackground: #fff;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tline-height: 1;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\ttransition: transform 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n\tspan {\n\t\tdisplay: block;\n\t\tline-height: 1;\n\t\tmargin-top: -1px;\n\t}\n\n\t&:hover:not(:disabled) {\n\t\tbackground: #dc3545;\n\t\tcolor: #fff;\n\t\ttransform: scale(1.3);\n\t}\n\n\t&:disabled {\n\t\tcursor: not-allowed;\n\t\topacity: 0.6;\n\t}\n}\n\n.media-viewer-button--bordered {\n\tborder: 1px solid #6c757d;\n\tborder-radius: 0.2rem;\n\tpadding: 0.25rem 0.5rem;\n\tline-height: 1;\n\ttransition: background-color 0.15s ease, color 0.15s ease;\n\n\t&:hover:not(:disabled) {\n\t\tbackground-color: #6c757d;\n\t\tcolor: #fff;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
